import type { IconName } from '@/shared/icons/types';

/**
 * Visuais compartilhados do lead (mockup app.html) — card `.tk-card` e Lista `.lv`.
 * Specs extraídas do CSS/JS do mockup (regra 1 da fidelidade): flame-hot/warm/cold,
 * CH map de ícones de canal, tuplas TEMP da pill de temperatura da Lista.
 */

/** Cores do flame de temperatura — `.c3-temp--hot/warm/cold` (tone-solid do DS). */
export const FLAME_COLORS: Record<'hot' | 'warm' | 'cold', string> = {
  hot: 'var(--theme-error-color)',
  warm: 'var(--theme-warning-color)',
  cold: 'var(--theme-info-color)',
};

/** Ícone mono do canal (mockup CH map: wa/ig/mail, fallback i-tag). */
export const CHANNEL_ICONS: Record<string, IconName> = {
  whatsapp: 'message-circle',
  instagram: 'instagram',
  facebook: 'facebook',
  messenger: 'message-square',
  telegram: 'send',
  email: 'mail',
  website: 'globe',
  phone: 'phone',
  google: 'search',
  youtube: 'youtube',
  tiktok: 'music',
  linkedin: 'linkedin',
  bing: 'search',
  other: 'tag',
};

/** Cor de marca por canal (mockup: pill com ícone colorido por canal). */
export const CHANNEL_COLORS: Record<string, string> = {
  whatsapp: '#22c55e',
  instagram: '#e1306c',
  facebook: '#1877f2',
  messenger: '#0084ff',
  telegram: '#229ed9',
  email: '#8b5cf6',
  website: '#64748b',
  phone: '#0ea5e9',
  google: '#4285f4',
  youtube: '#ff0000',
  tiktok: '#010101',
  linkedin: '#0a66c2',
  bing: '#008373',
  other: '#94a3b8',
};

/** Label pt-BR do canal — fallback textual quando falta descrição. */
export const CHANNEL_LABELS: Record<string, string> = {
  whatsapp: 'WhatsApp',
  instagram: 'Instagram',
  facebook: 'Facebook',
  messenger: 'Messenger',
  telegram: 'Telegram',
  email: 'E-mail',
  website: 'Website',
  phone: 'Telefone',
  google: 'Google',
  youtube: 'YouTube',
  tiktok: 'TikTok',
  linkedin: 'LinkedIn',
  bing: 'Bing',
  other: 'Outro',
};

/** Pill de temperatura da Lista (mockup TEMP: [label, bg, fg]) + Ganho. */
export const TEMP_PILLS: Record<'hot' | 'warm' | 'cold' | 'won', { label: string; bg: string; fg: string }> = {
  hot: { label: 'Quente', bg: 'var(--theme-error-subtle)', fg: 'var(--theme-error-fg)' },
  warm: { label: 'Morna', bg: 'var(--theme-warning-subtle)', fg: 'var(--theme-warning-fg)' },
  cold: { label: 'Fria', bg: 'var(--theme-info-subtle)', fg: 'var(--theme-info-fg)' },
  won: { label: 'Ganho', bg: 'var(--theme-success-subtle)', fg: 'var(--theme-success-fg)' },
};

/** Narrowing da temperatura aberta (`string & {}`) para as 3 chaves conhecidas. */
export const narrowTemperature = (t?: string): 'hot' | 'warm' | 'cold' | undefined =>
  t === 'hot' || t === 'warm' || t === 'cold' ? t : undefined;
